<template>
  <div class="industry-select">
    <el-dialog class="zwx-dialog " title="选择行业" :visible.sync="visible" @opened="opened()" @close="close()" :close-on-click-modal="false" :destroy-on-close="true" center>
      <el-form class="zwx-form" style="padding: 12px 20px" key="mainForm" ref="mainForm" :model="mainForm" label-position="right" @submit.native.prevent>
        <div style="text-align: left">
          <el-form-item style="margin-right: 16px; margin-bottom: 0" label-width="0" label="">
            <el-select class="zwx-select " v-model="mainForm.door" @change="msComponentCategoryDoorChange" placeholder="门类" clearable>
              <el-option v-for="item in industryObj.doors" :key="item.codeNo" :label="item.industryName" :value="item.codeNo"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="margin-right: 16px; margin-bottom: 0" label-width="0" label="">
            <el-select class="zwx-select " v-model="mainForm.big" @change="msComponentCategoryBigChange()" placeholder="大类" clearable>
              <el-option v-for="item in industryObj.bigs" :key="item.codeNo" :label="item.industryName" :value="item.codeNo"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="margin-right: 0 !important; margin-bottom: 0" label-width="0" label="">
            <el-select class="zwx-select " v-model="mainForm.medium" placeholder="中类" clearable>
              <el-option v-for="item in industryObj.mediums" :key="item.codeNo" :label="item.industryName" :value="item.codeNo"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div style="text-align: left">
          <el-form-item style="margin-right: 16px; margin-bottom: 0" label-width="0" label="">
            <el-input class="zwx-input" style="width: 244px!important ;" v-model.trim="mainForm.industryNameLike" placeholder="行业名称" clearable></el-input>
          </el-form-item>
          <el-form-item style="margin-right: 16px; margin-bottom: 0" label-width="0" label="">
            <el-input class="zwx-input" style="width: 244px!important ;" v-model.trim="mainForm.nationalStandardCode" placeholder="国标编码" clearable></el-input>
          </el-form-item>
          <el-button class="zwx-button zwx-button-icontext-28" style="min-width: unset" icon="el-icon-search" @click="search()">检索</el-button>
        </div>
      </el-form>
      <el-table class="zwx-table " row-key="rid" :data="mainForm.tableList" highlight-current-row stripe border height="380px">
        <el-table-column label="选择" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <div :class="industryObj.simpleCode && industryObj.simpleCode.rid === scope.row.rid ? 'radio-select is-checked' : 'radio-select'" :style="scope.row.industryNameList.length != undefined && scope.row.industryNameList.length >= checkLevel ? '' : 'background-color: #a4a6ab;pointer-events: none;cursor: not-allowed;'" @click="msComponentCategorySingleCircleClick(scope.row)"></div>
          </template>
        </el-table-column>
        <el-table-column label="门类" min-width="160" header-align="center" align="left">
          <template slot-scope="scope">
            <div>
              {{ scope.row.industryNameList.length != undefined && scope.row.industryNameList.length > 0 ? scope.row.industryNameList[scope.row.industryNameList.length - 1] : '' }}
              {{ scope.row.industryNameList.length != undefined && scope.row.industryNameList.length == 1 ? ($zwxBase.verifyIsNotBlank(scope.row.nationalStandardCode) ? '(' + scope.row.nationalStandardCode + ')' : '') : '' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="大类" min-width="160" header-align="center" align="left">
          <template slot-scope="scope">
            <div>
              {{ scope.row.industryNameList.length != undefined && scope.row.industryNameList.length > 1 ? scope.row.industryNameList[scope.row.industryNameList.length - 2] : '' }}
              {{ scope.row.industryNameList.length != undefined && scope.row.industryNameList.length == 2 ? ($zwxBase.verifyIsNotBlank(scope.row.nationalStandardCode) ? '(' + scope.row.nationalStandardCode + ')' : '') : '' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="中类" min-width="160" header-align="center" align="left">
          <template slot-scope="scope">
            <div>
              {{ scope.row.industryNameList.length != undefined && scope.row.industryNameList.length > 2 ? scope.row.industryNameList[scope.row.industryNameList.length - 3] : '' }}
              {{ scope.row.industryNameList.length != undefined && scope.row.industryNameList.length == 3 ? ($zwxBase.verifyIsNotBlank(scope.row.nationalStandardCode) ? '(' + scope.row.nationalStandardCode + ')' : '') : '' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小类" min-width="160" header-align="center" align="left">
          <template slot-scope="scope">
            <div>
              {{ scope.row.industryNameList.length != undefined && scope.row.industryNameList.length > 3 ? scope.row.industryNameList[scope.row.industryNameList.length - 4] : '' }}
              {{ scope.row.industryNameList.length != undefined && scope.row.industryNameList.length == 4 ? ($zwxBase.verifyIsNotBlank(scope.row.nationalStandardCode) ? '(' + scope.row.nationalStandardCode + ')' : '') : '' }}
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="footer">
        <el-pagination class="base-pagination" style="width:unset;box-sizing: border-box; padding-left: 16px" layout="total, prev, pager, next" @current-change="msComponentCategoryInquire()" :current-page.sync="mainForm.currentPage" :page-size="mainForm.pageSize" :total="mainForm.total"></el-pagination>
        <div style="display: flex;align-items: center">
          <el-button class="zwx-button zwx-button-32" type="primary" style="margin-right: 6px" @click="industryObj.simpleCode && msComponentCategoryDialogDetermine()" :disabled="!industryObj.simpleCode">确定</el-button>
          <el-button class="zwx-button zwx-button-32" style="margin-right: 16px" @click="visible = false">取消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'IndustrySelect',
  props: {
    checkLevel: { type: Number, default: 1 },
    interfaceName: { required: true, type: String },
    ifValidateIfLeaf: { type: Boolean, default: false },
  },
  data() {
    return {
      api: this.$store.state.api,
      mainForm: {
        tableList: [],
        currentPage: 1,
        pageSize: null,
        total: 0,
        door: null,
        big: null,
        medium: null,
        industryNameLike: '',
        nationalStandardCode: '',
      },
      industryObj: {
        doors: [],
        bigs: [],
        mediums: [],
        simpleCode: undefined,
      },
      visible: false,
      props: {
        codeTypeCode: { type: String, default: '' },
        checkLevel: { type: Number, default: 0 },
      },
    }
  },
  methods: {
    /**
     * 外部使用-打开弹框
     * */
    show(visible) {
      this.visible = visible
      this.industryInit()
      this.search()
    },
    opened() {
      this.$emit('opened')
    },
    close() {
      this.$emit('close')
      this.mainForm.tableList = []
      this.mainForm.currentPage = 1
      this.mainForm.pageSize = null
      this.mainForm.total = 0
      this.mainForm.door = null
      this.mainForm.big = null
      this.mainForm.medium = null
      this.mainForm.industryNameLike = ''
      this.industryObj.doors = []
      this.industryObj.bigs = []
      this.industryObj.mediums = []
      this.industryObj.simpleCode = undefined
    },
    cancel() {
      this.visible = false
    },
    /**
     * 初始化门类
     * */
    industryInit: function() {
      let data = {}
      this.$system.get(this.api + this.interfaceName + '/getIndustryClassificationListTree-0', data, true, true, this.searchSuccess, this.error)
    },
    searchSuccess(data) {
      if (data.type === '00') {
        this.industryObj.doors = data.industryClassificationExpList
      }
    },
    error() {},
    /**
     * 行业搜索
     * */
    search: function() {
      this.mainForm.currentPage = 1
      this.msComponentCategoryInquire()
    },
    msComponentCategoryInquire: function() {
      let levelCodeNo = null
      let door = this.mainForm.door
      if (door !== null) {
        levelCodeNo = door
        let big = this.mainForm.big
        if (big !== null) {
          levelCodeNo += '.' + big
          let medium = this.mainForm.medium
          if (medium !== null) {
            levelCodeNo += '.' + medium
          }
        }
      }
      let data = {
        levelCodeNo: levelCodeNo,
        industryNameLike: this.mainForm.industryNameLike,
        nationalStandardCode: this.mainForm.nationalStandardCode,
        currentPage: this.mainForm.currentPage,
      }
      this.$system.get(this.api + this.interfaceName + '/getTreeIndustryClassificationList-0', data, true, true, this.msComponentCategoryInquireSuccess, this.error)
    },
    msComponentCategoryInquireSuccess(data) {
      if (data.type === '00') {
        this.mainForm.total = data.industryClassificationExpCount
        this.mainForm.pageSize = data.pageSize
        let arr = data.industryClassificationExpList
        if (arr != undefined && arr.length != undefined && arr.length > 0) {
          for (let i in arr) {
            let industryNameList = []
            this.dealComponentCategoryLevel(industryNameList, arr[i])
            arr[i].industryNameList = industryNameList
          }
        }
        this.mainForm.tableList = arr
      }
    },
    //行业层级处理
    dealComponentCategoryLevel(industryNameList, industry) {
      if (industry.levelCodeNo != undefined && industry.levelCodeNo != null && industry.levelCodeNo != '' && industry.levelCodeNo.indexOf('.') != -1) {
        industryNameList.push(industry.industryName)
        //取出父类
        this.dealComponentCategoryLevel(industryNameList, industry.parentIndustryClassification)
      } else {
        industryNameList.push(industry.industryName)
      }
    },

    /**
     * 门类选中发生改变
     * */
    msComponentCategoryDoorChange: function(v) {
      this.mainForm.big = null
      this.industryObj.bigs = null
      this.mainForm.medium = null
      this.industryObj.mediums = null
      var door = this.mainForm.door
      if (this.$zwxBase.verifyIsBlank(door)) {
        return
      }
      let data = {
        codeNo: door,
      }
      this.$system.get(this.api + this.interfaceName + '/getIndustryClassificationListTree-0', data, true, true, this.msComponentCategoryBigSuccess, this.error)
    },
    msComponentCategoryBigSuccess(data) {
      if (data.type === '00') {
        this.industryObj.bigs = data.industryClassificationExpList
      }
    },
    /**
     * 大类选中发生改变
     * */
    msComponentCategoryBigChange: function() {
      this.mainForm.medium = null
      this.industryObj.mediums = null
      var big = this.mainForm.big
      if (this.$zwxBase.verifyIsBlank(big)) {
        return
      }
      let data = {
        codeNo: big,
      }
      this.$system.get(this.api + this.interfaceName + '/getIndustryClassificationListTree-0', data, true, true, this.msComponentCategoryMediumSuccess, this.error)
    },
    msComponentCategoryMediumSuccess(data) {
      if (data.type === '00') {
        this.industryObj.mediums = data.industryClassificationExpList
      }
    },
    msComponentCategorySingleCircleClick: function(simpleCode) {
      if (this.industryObj.simpleCode && this.industryObj.simpleCode.rid === simpleCode.rid) {
        this.industryObj.simpleCode = undefined
      } else {
        this.industryObj.simpleCode = simpleCode
      }
    },
    /**
     * 确定触发外部change事件
     * */
    msComponentCategoryDialogDetermine: function() {
      if (this.ifValidateIfLeaf) {
        let ifLeaf = this.industryObj.simpleCode.ifLeaf
        if (!ifLeaf) {
          this.$system.notify('错误', '请选择最下级行业分类', 'error')
        } else {
          this.$emit('change')
          this.visible = false
        }
      } else {
        this.$emit('change')
        this.visible = false
      }
    },
    /**
     * 外部使用-获取选中的对象
     * */
    msCategoryGet: function() {
      if (this.industryObj.simpleCode) {
        return this.industryObj.simpleCode
      }
      return null
    },
  },
}
</script>

<style lang="less" scoped></style>

<style lang="less">
.industry-select {
  .el-dialog {
    width: 805px;
  }

  .zwx-dialog .el-dialog__body {
    padding: 0;
  }

  .zwx-dialog .el-dialog__footer > div {
    display: flex !important;
    justify-content: space-between !important;
  }

  .zwx-dialog .el-dialog__footer {
    border-top: none !important;
  }

  .zwx-dialog .el-input__inner {
    width: 244px !important;
  }
}

/**单选圈*/
.radio-select {
  position: relative;
  width: 16px;
  height: 16px;
  margin: 0 auto;
  background-color: #ffffff;
  border-radius: 100%;
  border: 1px solid #dcdfe6;
  cursor: pointer;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.radio-select:hover {
  border-color: #20a0ff;
}

.radio-select:after {
  position: absolute;
  content: '';
  width: 6px;
  height: 6px;
  left: 4px;
  top: 4px;
  border-radius: 100%;
  background-color: #ffffff;
}

.radio-select.is-checked {
  border-color: #20a0ff;
  background-color: #20a0ff;
}
</style>
